import React, { createContext, FC, ReactNode, useContext, useEffect, useState } from 'react';
import type { PluginListenerHandle } from '@capacitor/core';
import { Network } from '@capacitor/network';

interface NetworkStatusContextProps {
  isOnline: boolean;
}

const NetworkStatusContext = createContext<NetworkStatusContextProps>({ isOnline: true });

// eslint-disable-next-line react-refresh/only-export-components
export const useNetworkStatus: () => NetworkStatusContextProps = () => useContext(NetworkStatusContext);

export const NetworkStatusProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    let pluginListener: PluginListenerHandle;

    const setup = async () => {
      const status = await Network.getStatus();
      setIsOnline(status.connected);

      pluginListener = await Network.addListener('networkStatusChange', (status) => {
        setIsOnline(status.connected);
      });
    };

    setup();

    // Cleanup
    return () => {
      pluginListener?.remove();
    };
  }, []);

  return <NetworkStatusContext.Provider value={{ isOnline }}>{children}</NetworkStatusContext.Provider>;
};
